import DataItem from '../common/data-item';
import performance from '../../performance/performance';

export default class AppLoadingPhaseItem extends DataItem {
  constructor({ name, index, phaseStartTime }) {
    super({});

    const now = performance.now();
    this.data.name = name;
    this.data.duration = Math.floor(now - phaseStartTime);
    this.index = index;
  }
}
